export default class TrsxParagraph {
    constructor(speaker, begin, end, forceLabel, captionMetadata, notForTraining = null) {
        this.s = speaker;
        this.begin = begin;
        this.end = end;
        this.forceLabel = forceLabel;
        this.phrases = [];
        this.captionMetadata = captionMetadata;
        this.notForTraining = notForTraining;
    }
    addPhrase(phrase) {
        this.phrases.push(phrase);
    }
    serialize() {
        const citation = this.notForTraining !== null ? ` notForTraining="${this.notForTraining}"` : '';
        // Parameter captionsForceSpeakerSign was requested by Marek Bohac.
        // It forces speaker sign in subtitles even when speaker does not change.
        // For now it is always the same as scribeForceLabel.
        const header = `      <pa s="${this.s}" b="${this.begin}" e="${this.end}" scribeForceLabel="${this.forceLabel}" captionsForceSpeakerSign="${this.forceLabel}"${citation}>\n`;
        const inner = this.phrases.map((p) => p.serialize()).join('');
        const footer = '      </pa>\n';
        return header + inner + footer;
    }
}
